import ko from 'knockout'
import Base from '../../core/base'
class Radio extends Base {
  initialize (params) {
    this.value = params.value || ko.observable()
    this.fieldid = params.fieldid || this.value._fieldid || ''
    this.dataList = (params.dataList && params.dataList.subscribe) ? params.dataList : (ko.observableArray(params.dataList || []))
    this.direction = params.direction || 'horizontal'
    this.radioname = 'y-radio' + Math.random()
    this.onChange = params.onChange || function () {}
  }
}

export default Radio



// WEBPACK FOOTER //
// ./src/components/radio/base.js